import { render, staticRenderFns } from "./SportFootballMatch.vue?vue&type=template&id=d3a42e66"
import script from "./SportFootballMatch.vue?vue&type=script&lang=js"
export * from "./SportFootballMatch.vue?vue&type=script&lang=js"
import style0 from "./SportFootballMatch.vue?vue&type=style&index=0&id=d3a42e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports